import { Injectable, Inject } from '@angular/core';
import { ApiActionState, ApiCollection, assertMeta, HANDLE_RESPONSE_ACTION, HttpClient } from '@beecore/api';

import { ConfigService } from '@beecore/core';
import { IMenuCollection } from '@beecore/startup';
import { ISfeConstants } from 'src/app/startup/interfaces/i-sfe-constants';
import { SFE_CONSTANTS_TOKEN } from 'src/app/startup/tokens/sfe-constants.token';

@Injectable({
  providedIn: 'root'
})
export class SfeMenuService {

  constructor(
    protected readonly $http: HttpClient,
    protected readonly config: ConfigService,
    @Inject(SFE_CONSTANTS_TOKEN) protected readonly constants: ISfeConstants) { }

  getMenus(companyId: number) {
    return this.$http
      .get<ApiCollection<IMenuCollection>>(
        `${this.config.get(this.constants.keyApi)}/menu?codEmpresa=${companyId}`,
        { meta: assertMeta([[HANDLE_RESPONSE_ACTION, { enabled: ApiActionState.Enabled }]]) }
      );
  }
}
